import { StoreInitialValues } from "@multicines/stores";

import { ModalsStoreValues } from "./modals.store.types";

export const defaultValues: StoreInitialValues<ModalsStoreValues> = {
  privacyPoliticsModalVisible: false
};
